export const MOBILEUSER_REQUEST = "MOBILEUSER_REQUEST";
export const MOBILEUSER_SUCCESS = "MOBILEUSER_SUCCESS";
export const  MOBILEUSER_FAILURE = "MOBILEUSER_FAILURE";